// src/pages/SavedPosts.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebase-config';
import { doc, getDoc } from 'firebase/firestore'; 
import NewsCard from '../components/newsCard';
import './PageStyles.css';

const SavedPosts = () => {
  const { currentUser } = useAuth();
  const [savedNews, setSavedNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSavedPosts = async () => {
      if (!currentUser) return;
      setLoading(true);
      try {
        // 1. Get the user's saved post IDs from their profile
        const userDocRef = doc(db, 'users', currentUser.uid);
        const userDoc = await getDoc(userDocRef);
        
        if (userDoc.exists() && userDoc.data().savedPosts?.length > 0) {
          const savedPostIds = userDoc.data().savedPosts;
          
          // 2. Fetch documents individually
          const newsPromises = savedPostIds.map(id => getDoc(doc(db, 'userNews', id)));
          
          // --- CRITICAL FIX START ---
          // Use allSettled instead of all.
          // If a post was deleted, 'getDoc' throws an error.
          // 'allSettled' catches that error and lets the other posts load safely.
          const results = await Promise.allSettled(newsPromises);
          
          const newsList = results
            // Only keep the ones that succeeded (status === 'fulfilled') 
            // AND actually exist in the database
            .filter(result => result.status === 'fulfilled' && result.value.exists()) 
            .map(result => ({ id: result.value.id, ...result.value.data() }));
          // --- CRITICAL FIX END ---

          setSavedNews(newsList);
        } else {
          setSavedNews([]);
        }
      } catch (error) {
        console.error("Error fetching saved posts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchSavedPosts();
  }, [currentUser]);

  return (
    <div className="page-container">
      <h1>Saved Posts</h1>
      {loading ? (
        <p>Loading saved posts...</p>
      ) : savedNews.length > 0 ? (
        <div className="news-grid">
          {savedNews.map(item => <NewsCard key={item.id} newsItem={item} />)}
        </div>
      ) : (
        <p>You haven't saved any posts yet.</p>
      )}
    </div>
  );
};

export default SavedPosts;